<template>
  <div class="text-center">
    <v-dialog persistent v-model="visible" width="800">
      <v-card class="not-margin pt-0 pr-0 pl-0">
        <v-toolbar dark color="primary">
          <div class="text-center">
            <v-icon>mdi-eye</v-icon> Visualizar Aba
          </div>
        </v-toolbar>
        <div class="container dialog">
          <v-row class="d-flex justify-center mt-7">
            <v-col cols="12">
              <v-text-field
                :value="content.nome"
                label="Nome da Aba*"
                readonly
                outlined
                dense
              ></v-text-field>
            </v-col>
          </v-row>
          <v-row class="d-flex justify-center mt-7">
            <v-col cols="12">
              <v-text-field
                :value="content.nomeDeExibicao"
                label="Nome de Exibição*"
                readonly
                outlined
                dense
              ></v-text-field>
            </v-col>
          </v-row>
          <v-row class="d-flex justify-center">
            <v-col cols="12">
              <span class="small">Permissões*</span>
              <div class="permission-box">
                <v-chip-group active-class="primary--text" column>
                  <v-chip v-for="permissao in content.permissoes" :key="permissao.id">
                    {{ permissao.nomeDeExibicao }}
                  </v-chip>
                </v-chip-group>
              </div>
            </v-col>
          </v-row>
        </div>
        <div class="btn-group text-center">
          <v-btn color="primary" outline @click="$emit('onClose')">
            Fechar
          </v-btn>
        </div>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { DialogProps } from '~/commons/classes/dialog-props';
import { Aba } from '~/commons/classes/aba';

export default {
  props: new DialogProps(Aba),
};
</script>
<style scoped>
.permission-box {
  border: 1px solid #ccc;
  padding: 10px;
  border-radius: 4px;
  background-color: #ffffff;
  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.1);
  margin-top: 10px;
}
</style>